import { render } from "./ItemsGroupsView.vue?vue&type=template&id=3b6a4377&ts=true"
import script from "./ItemsGroupsView.vue?vue&type=script&lang=ts"
export * from "./ItemsGroupsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__